export default __webpack_public_path__ + "static/l5-hero-img-89a6458eab2b63ce4892802964b0893c.png";